import React from 'react';
export function CTASection() {
  return <section id="contact" className="py-16 bg-red-700 text-white" data-id="element-35">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="max-w-4xl mx-auto text-center" data-id="element-37">
          <h2 className="text-3xl font-bold mb-6" data-id="element-38">
            Contact Fire Safety Displays For More Info
          </h2>
          <p className="text-xl mb-8 opacity-90" data-id="element-39">
            Our page is currently under construction. Please contact us for more
            information about our fire safety solutions.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-40">
            <a href="#" className="px-8 py-3 bg-white text-red-700 font-medium rounded-md hover:bg-gray-100 transition duration-300" data-id="element-41">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>;
}